import styled, { css } from "styled-components";

import { Divider as DefaultDivider } from "@material-ui/core";

import DefaultRow from "components/Form/Row";
import { UploadPreviewFieldControl as DefaultUploadPreviewFieldControl } from "components/FormControl";
import { ImageContainer } from "components/FormControl/UploadPreviewFieldControl/styles";

import { COLORS } from "constants/colorScheme";

export const BackButtonWrapper = styled.div`
  display: flex;
  margin-left: 26px;
`;

export const Container = styled.div`
  padding: 32px;

  background-color: ${COLORS.WHITE};
  border-radius: 10px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-bottom: 40px;
`;

export const ControlContainer = styled.div`
  width: 120px;

  &:not(:last-child) {
    margin-right: 32px;
  }
`;

export const GroupRow = styled.div`
  display: flex;
  flex-direction: row;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;

  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "100%"};
    `}

  &:not(:last-child) {
    margin-right: 32px;
  }
`;

export const Row = styled(DefaultRow)`
  margin-bottom: 0;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const UploadPreviewFieldControl = styled(
  DefaultUploadPreviewFieldControl,
)`
  ${ImageContainer} {
    height: 240px;

    .filepicker {
      height: 240px;
    }

    .dropzone .dz-message {
      margin: 100px 0;
    }

    .dropzone .dz-preview .dz-image {
      width: 170px;
      height: 170px;
    }
  }
`;

export const GroupRowLabelContainer = styled(DefaultRow)`
  margin-bottom: 10px;
`;

export const Divider = styled(DefaultDivider)`
  && {
    background-color: ${COLORS.WHITE};
  }
`;

export const PublishStatusWrapper = styled.div`
  margin-left: 32px;
`;

export const SectionsCardWrapper = styled.div`
  margin-top: 12px;
`;
